import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import colors, { hover } from '../../../styling/colors';
import button from '../../../styling/mixins/button';

export const defaultButtonStyles = ({
  color,
  backgroundColor,
  borderRadius,
}) => css`
  ${button} 
  background-color: ${colors(backgroundColor || color)};
  border-color: ${colors(backgroundColor || color)};
  color: ${color === 'white' ? colors('lapel') : 'white'};
  border-radius: ${borderRadius};

  @media (hover: hover) {
    &:hover {
      background-color: ${hover(backgroundColor || color)};
      border-color: ${hover(backgroundColor || color)};
    }
  }
`;

const DefaultButton = styled.button`
  ${defaultButtonStyles};
`;

DefaultButton.propTypes = {
  borderRadius: PropTypes.string,
  children: PropTypes.any.isRequired,
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  onClick: PropTypes.func,
};

DefaultButton.defaultProps = {
  color: 'lapel',
  borderRadius: '0',
};

DefaultButton.displayName = 'DefaultButton';

export default DefaultButton;
